// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__GWe7i","options":"AnswerScale_options__CQ9yp","selected":"AnswerScale_selected__3GOqc"};